import { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import SocieteAndUserService from "../../services/societeAndUser";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";

/*
 * Quick "new client" dialog for the sales document forms. Creates the client
 * with the same payload as a "client passager" of the Tiers page, then hands
 * the created company back to the form so it can be selected right away.
 */
const QuickAddClient = ({ onClose, onCreated }) => {
  const [form, setForm] = useState({
    title: "",
    numPhone: "",
    email: "",
    adresse: "",
    matricule: "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const submit = () => {
    if (saving) return;
    if (form.title.trim() === "") {
      setError("Le nom du client est obligatoire");
      return;
    }
    setSaving(true);
    setError("");
    const model = {
      title: form.title.trim(),
      matricule: form.matricule.trim() || "-",
      adresse: form.adresse.trim() || "-",
      idUserCreation: getCurrentUserId(),
      typeSociete: "P",
      codeTVA: "A",
      codeCategorie: "M",
      numberEtabSecondaire: "000",
      email: form.email.trim() || "-",
      numPhone: form.numPhone.trim() || "-",
      typeTVA: "Normale",
      timbre: 1,
      tva: "0",
      typeClient: "CLIENT",
      file: null,
    };
    SocieteAndUserService.addSociete(model)
      .then((res) => {
        const created = res.data && res.data.societeSuccess;
        if (created && created.id !== undefined) {
          onCreated(created);
          onClose();
        } else {
          setError("Le client n'a pas pu être créé");
          setSaving(false);
        }
      })
      .catch(() => {
        setError("Erreur : il y a un problème de connexion");
        setSaving(false);
      });
  };

  return (
    <Dialog open={true} onClose={saving ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Nouveau client</DialogTitle>
      <DialogContent>
        <div className="form-group mt-2">
          <label htmlFor="qcTitle">
            Nom / Raison sociale <span style={{ color: "red" }}>*</span>
          </label>
          <input
            id="qcTitle"
            className="form-control"
            value={form.title}
            onChange={set("title")}
            autoFocus
          />
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="qcPhone">Téléphone</label>
              <input id="qcPhone" className="form-control" value={form.numPhone} onChange={set("numPhone")} />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="qcEmail">Email</label>
              <input id="qcEmail" type="email" className="form-control" value={form.email} onChange={set("email")} />
            </div>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="qcAdresse">Adresse</label>
          <input id="qcAdresse" className="form-control" value={form.adresse} onChange={set("adresse")} />
        </div>
        <div className="form-group">
          <label htmlFor="qcMat">Matricule fiscal</label>
          <input id="qcMat" className="form-control" value={form.matricule} onChange={set("matricule")} />
        </div>
        <small className="text-muted">
          Les autres informations (TVA, seuil, conditions) peuvent être complétées plus tard dans la page Tiers.
        </small>
        {error && <div className="alert alert-danger mt-3 mb-0">{error}</div>}
      </DialogContent>
      <DialogActions>
        <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={saving}>
          Annuler
        </button>
        <button type="button" className="btn btn-dark" onClick={submit} disabled={saving}>
          <i className="fas fa-user-plus mr-1"></i>Ajouter le client
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default QuickAddClient;
